/**
 * ReportsHarvestInspectionsTableRow
 */
import React from 'react';

import { Table } from 'semantic-ui-react';

// Components
import ReportsHarvestInspectionsPersonFirstName from '../../../../../../../../components/ReportsHarvestInspectionsPersonFirstName';
import ReportsHarvestInspectionsPersonLastName from '../../../../../../../../components/ReportsHarvestInspectionsPersonLastName';
import ReportsHarvestInspectionsPersonNumberOfInspections from '../../../../../../../../components/ReportsHarvestInspectionsPersonNumberOfInspections';
import ReportsHarvestInspectionsPersonPickerFaultPercentage from '../../../../../../../../components/ReportsHarvestInspectionsPersonPickerFaultPercentage';

interface Props {
    personId?: ?number;
}

export default class ReportsHarvestInspectionsTableRow extends React.PureComponent<Props> {
    static defaultProps = {
        personId: null
    };

    render() {
        const { personId } = this.props;
        return (
            <Table.Row>
                <Table.Cell>
                    <ReportsHarvestInspectionsPersonFirstName
                        personId={personId}
                    />
                </Table.Cell>
                <Table.Cell>
                    <ReportsHarvestInspectionsPersonLastName
                        personId={personId}
                    />
                </Table.Cell>
                <Table.Cell>
                    <ReportsHarvestInspectionsPersonNumberOfInspections
                        personId={personId}
                    />
                </Table.Cell>
                <Table.Cell>
                    <ReportsHarvestInspectionsPersonPickerFaultPercentage
                        personId={personId}
                    />
                </Table.Cell>
            </Table.Row>
        );
    }
}
